import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import View from './view';
import { user } from '../../../modules';

const Component = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handlers = {
    onLogout: () => dispatch(user.logout.action()),
  };

  return <View handlers={handlers} t={t} />;
};

export default Component;
